
export default function projectsSearch(searchString, projects) {

	//console.log(searchString);
	//console.log(projects);

	if (searchString.length >= 2){

		searchString = searchString.toLowerCase(); // case insensitive string search

		//=====================
		// search in projects

		//console.log(projects);

		let foundProjects = [];
		for (let key in projects){
			let project = projects[key];
			if(project['name'].toLowerCase().indexOf(searchString) !== -1){
				foundProjects.push(project);
			}
		}

		console.log(foundProjects);

		//=====================
		// search in users

		for (let key in projects){

			//console.log(project['usersList']);


			for(let userKey in projects[key]['usersList']){

				let project = Object.assign({}, projects[key]);
				let user = Object.assign(project['usersList'][userKey]);
				user.id = userKey;
				if(
					user['firstName'].toLowerCase().indexOf(searchString) !== -1 ||
					user['lastName'].toLowerCase().indexOf(searchString) !== -1 ||
					user['phone'].indexOf(searchString) !== -1
				){
					console.log(project.name + ' ===> ' + user.firstName);

					console.log(project['userFoundInSearch']);
					//console.log(user);

					project['userFoundInSearch'] = user;

					console.log(project['userFoundInSearch']);

					foundProjects.push(project);

					console.log(foundProjects);
				}

			}
		}

		console.log(foundProjects);

		//======================

		//console.log('foundProjects');
		//console.log(foundProjects);

		return foundProjects;

	} else {

		return false;
	}
}
